import { createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/img/mail.svg'


const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h4", { class: "text-xl font-bold text-primary mb-3" }, "Radicar PQR", -1)
const _hoisted_3 = { class: "flex flex-row items-center mb-4" }
const _hoisted_4 = { class: "mr-3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "mb-1 text-xs font-bold text-left text-primary" }, " Tipo de documento ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("option", { class: "text-xs" }, "CC", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("option", { class: "text-xs" }, "CE", -1)
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { class: "flex-1" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "mb-1 text-xs font-bold text-left text-primary" }, " Número de documento ", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "mb-1 text-xs font-bold text-left text-primary" }, " Nombre de contacto ", -1)
const _hoisted_12 = { class: "flex flex-row items-center" }
const _hoisted_13 = { class: "mr-3" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "mb-1 text-xs font-bold text-left text-primary" }, " Teléfono de contacto ", -1)
const _hoisted_15 = { class: "mb-4 text-red-500 text-xs" }
const _hoisted_16 = { class: "flex-1" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs font-bold text-left text-primary mb-1" }, "Asunto", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  class: "text-xs"
}, "Seleccione", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("option", {
  value: "peticion",
  class: "text-xs"
}, "Petición", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("option", {
  value: "queja",
  class: "text-xs"
}, "Queja", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("option", {
  value: "reclamo",
  class: "text-xs"
}, "Reclamo", -1)
const _hoisted_22 = { class: "mb-4 text-red-500 text-xs" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("p", { class: "mb-1 text-xs font-bold text-left text-primary" }, " Correo electrónico ", -1)
const _hoisted_24 = { class: "mb-4 text-red-500 text-xs" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs font-bold text-left text-primary" }, "Mensaje", -1)
const _hoisted_26 = { class: "mb-4 text-red-500 text-xs" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("p", { class: "mb-1 text-xs font-bold text-left text-primary" }, " Adjuntar Archivo ", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-center mt-4" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "submit",
    class: "px-4 py-2 text-white rounded bg-primary"
  }, " Enviar ")
], -1)
const _hoisted_29 = { key: 1 }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("h4", { class: "text-xl font-bold text-primary mb-4" }, "¿Necesita ayuda?", -1)
const _hoisted_31 = { class: "grid gap-2" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("img", {
  class: "float-left",
  src: _imports_0,
  alt: "radique pqr icono"
}, null, -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("button", { class: "col-span-4 text-left" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "text-sm font-bold text-left text-primary ml-4" }, " Radique una Solicitud ")
], -1)
const _hoisted_34 = [
  _hoisted_32,
  _hoisted_33
]
const _hoisted_35 = {
  key: 1,
  class: "fixed inset-0 z-20 bg-black opacity-25"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_Form = _resolveComponent("Form")!
  const _component_NewModal = _resolveComponent("NewModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isVisible)
      ? (_openBlock(), _createBlock(_component_NewModal, {
          key: 0,
          "custom-class": 'p-4 lg:p-6 max-w-2xl w-80 lg:w-96 bg-white rounded-lg',
          onCloseModal: _ctx.cancel
        }, {
          default: _withCtx(() => [
            (_ctx.showForm)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _hoisted_2,
                  _createVNode(_component_Form, {
                    onSubmit: _ctx.sendData,
                    "validation-schema": _ctx.schemaForm
                  }, {
                    default: _withCtx(({ errors }) => [
                      _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                          _hoisted_5,
                          _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.fillForm.documentType) = $event)),
                            disabled: "",
                            class: "w-36 lg:w-40 p-2 text-xs border border-gray-300 rounded-md text-gris120 h-9"
                          }, _hoisted_8, 512), [
                            [_vModelSelect, _ctx.fillForm.documentType]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_9, [
                          _hoisted_10,
                          _withDirectives(_createElementVNode("input", {
                            disabled: "",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.fillForm.noDocument) = $event)),
                            class: "w-full p-1 border border-gray-300 rounded-md h-9 md:text-left text-gris120"
                          }, null, 512), [
                            [_vModelText, _ctx.fillForm.noDocument]
                          ])
                        ])
                      ]),
                      _hoisted_11,
                      _withDirectives(_createElementVNode("input", {
                        disabled: "",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.fillForm.name) = $event)),
                        class: "w-full p-1 mb-4 border border-gray-300 rounded-md md:text-left text-gris120 h-9"
                      }, null, 512), [
                        [_vModelText, _ctx.fillForm.name]
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                          _hoisted_14,
                          _createElementVNode("div", null, [
                            _createVNode(_component_Field, {
                              name: "phone_number",
                              type: "text",
                              as: "input",
                              class: _normalizeClass(["w-36 lg:w-40 p-1 border border-gray-300 rounded-md md:text-left text-gris120 h-9", { 'border border-primary': errors.phone_number }])
                            }, null, 8, ["class"]),
                            _createElementVNode("div", _hoisted_15, _toDisplayString(errors.phone_number), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_16, [
                          _hoisted_17,
                          _createVNode(_component_Field, {
                            name: "request",
                            as: "select",
                            class: _normalizeClass(["relative w-full p-2 text-xs border border-gray-300 rounded-md h-9 text-gris120", { 'border border-primary': errors.request }]),
                            "validate-on-input": true
                          }, {
                            default: _withCtx(() => [
                              _hoisted_18,
                              _hoisted_19,
                              _hoisted_20,
                              _hoisted_21
                            ]),
                            _: 2
                          }, 1032, ["class"]),
                          _createElementVNode("div", _hoisted_22, _toDisplayString(errors.request), 1)
                        ])
                      ]),
                      _hoisted_23,
                      _createVNode(_component_Field, {
                        name: "email",
                        type: "email",
                        as: "input",
                        class: _normalizeClass(["w-full p-1 border border-gray-300 rounded-md md:text-left text-gris120 h-9", { 'border border-primary text-xs': errors.email }])
                      }, null, 8, ["class"]),
                      _createElementVNode("div", _hoisted_24, _toDisplayString(errors.email), 1),
                      _hoisted_25,
                      _createVNode(_component_Field, {
                        name: "message",
                        as: "textarea",
                        class: _normalizeClass(["w-full p-1 border border-gray-300 rounded-md md:text-left text-gris120 text-xs resize-none", { 'border border-primary': errors.message }]),
                        rows: "4",
                        placeholder: "Indique aquí su solicitud."
                      }, null, 8, ["class"]),
                      _createElementVNode("div", _hoisted_26, _toDisplayString(errors.message), 1),
                      _hoisted_27,
                      _createElementVNode("input", {
                        type: "file",
                        onChange: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.uploadFile && _ctx.uploadFile(...args)), ["prevent"])),
                        ref: "uploadFile",
                        class: "w-full p-1 mb-3 border border-gray-300 rounded-md md:text-left text-gris120 h-9"
                      }, null, 544),
                      _hoisted_28
                    ]),
                    _: 1
                  }, 8, ["onSubmit", "validation-schema"])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_29, [
                  _hoisted_30,
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("div", {
                      class: "flex",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showForm = true))
                    }, _hoisted_34)
                  ])
                ]))
          ]),
          _: 1
        }, 8, ["onCloseModal"]))
      : _createCommentVNode("", true),
    (_ctx.isVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_35))
      : _createCommentVNode("", true)
  ], 64))
}